export default (data, keys) => {
  keys.forEach(key => {
    if (data[key]) {
      data[key] = data[key].toString().replace(/\D+/g, "")
    }
  });
  return data
}
